var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRinseAidValveOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 21",
    style: {
      enableBackground: "new 0 0 72 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E9CC63;}\r\n\t.st1{fill:#FF16E3;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#6A7084;}\r\n\t.st4{fill:#2F323A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 9.2,
    className: "st0",
    width: 72,
    height: 3.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.42,12.17 23.38,19.76 23.38,1.24 34.42,8.83 45.47,1.24 45.47,19.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.82,2.49v8.01v8.01l-5.83-4.01l-4.56-3.13l-4.56,3.13l-5.83,4.01V10.5V2.49l5.83,4.01l4.56,3.13 l4.56-3.13L44.82,2.49 M46.12,0l-2.03,1.39L38.26,5.4l-3.83,2.63L30.59,5.4l-5.83-4.01L22.73,0v2.49v8.01v8.01V21l2.03-1.39 l5.83-4.01l3.83-2.63l3.83,2.63l5.83,4.01L46.12,21v-2.49V10.5V2.49V0L46.12,0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRinseAidValveOn);
export default __webpack_public_path__ + "static/media/rinse_aid_valve_on.64c2fa8efc6312e64871c86609dbc5e0.svg";
export { ForwardRef as ReactComponent };